'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _propTypes=require('prop-types'),_propTypes2=_interopRequireDefault(_propTypes);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var i18nShape=_propTypes2.default.shape({direction:_propTypes2.default.oneOf(['ltr','rtl','auto']),language:_propTypes2.default.string,t:_propTypes2.default.func});exports.default=i18nShape;


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/propTypes/i18nShape.js
 **/